import { render, staticRenderFns } from "./TournamentsPage.vue?vue&type=template&id=8b825a02&scoped=true&"
import script from "./TournamentsPage.vue?vue&type=script&lang=js&"
export * from "./TournamentsPage.vue?vue&type=script&lang=js&"
import style0 from "./TournamentsPage.vue?vue&type=style&index=0&id=8b825a02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b825a02",
  null
  
)

export default component.exports